// @flow strict
import * as React from 'react';
import { Device } from '@ta/lithium.context';

const buggySafariVersions: number[] = [9, 10];
// Chrome and Safari on iOS are basically using the same engine, and the webkit versions of these iOS versions have the same flex issues as IE
const buggyiOSVersions: number[] = [9, 10];

/**
 * Returns true if the user is currently using an old, buggy Webkit browser
 * @returns {boolean}
 */
const useBuggyWebkit = () => {
  const { browser, os } = React.useContext(Device);
  return (
    (browser.family === 'SAFARI' &&
      // Don't test buggy UI displays
      /* istanbul ignore next */
      buggySafariVersions.includes(browser.majorVersion)) ||
    (os.family === 'IOS' &&
      // ditto
      /* istanbul ignore next */
      buggyiOSVersions.includes(os.majorVersion))
  );
};

export default useBuggyWebkit;
